import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const ACTIVATECARD = gql`
  mutation setCardActive($id: ID!) {
    setCardActive(id: $id)
  }
`;
function ActiveCard({ id, name, children, onActivateCard }) {
    const [runActivateCard, setActivateCard] = useMutation(ACTIVATECARD, {
        onCompleted({ setCardActive }) {
          if (setCardActive) {
            message.success(`کارت ${name ? name : ""} فعال شد.`);
            onActivateCard();
          } else {
            message.error("متاسفانه مشکلی پیش آمده!کارت کاربر فعال نشد.");
          }
        },
        onError() {
          message.error("متاسفانه مشکلی پیش آمده!کارت کاربر فعال نشد.");
        },
      });
      const doActivateCard = () => {
        runActivateCard({
          variables: { id },
        });
      };
    return (
        <>
        <Popconfirm
          title={`فعال کردن ${name ? "کارت " + name : "کارت کاربر"}?`}
          okText="فعال کردن"
          cancelText="خیر"
          onConfirm={doActivateCard}
        >
          <span>{children}</span>
        </Popconfirm>
      </>
    );
}

export default ActiveCard;